import {
  getClientesZonasPanel,
  deleteClienteZona,
} from "../../../../../services/ClientesZonasServices";

export const getDataGrid = async (zona_id, searchTerm, page, perPage) => {
  return await getClientesZonasPanel(zona_id, searchTerm, page, perPage);
};

export const deleteDataGrid = async (id) => {
  return await deleteClienteZona(id);
};
